import { ApiErrorResponse } from "../../types";
import { errorIsFromApi } from "../errorIsFromApi";
import { navigateToAdmin } from "../navigateToAdmin";

export async function postFileRequestWrapper<Body, Response>({
  url,
  body,
  file,
}: {
  url: string;
  body?: Body;
  file?: File;
}): Promise<Response> {
  // formate Data
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  if (body) {
    for (const [key, value] of Object.entries(body)) {
      // @ts-expect-error - value is unknown
      formData.append(key, value);
    }
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
    },
    body: formData,
    credentials: "include",
  });

  if (!response.ok) {
    const error: unknown = await response.json();

    // TODO - Add functionality to detect error type and print error.
    if (errorIsFromApi(error)) {
      const {
        error: { message, code },
      }: ApiErrorResponse = error as ApiErrorResponse;

      if (code === -100) {
        // Authentication failed.
        navigateToAdmin();
      }

      throw new Error(`Api Responsed with an error: ${code}: ${message}`);
    }

    throw new Error(`Error encountered when making POST request to "${url}"`);
  }

  return response.json() as Response;
}
